import AXIOS from "./axios";

export class Appointments {
  static create(payload) {
    return AXIOS.post("/appointments", { appointment: payload });
  }

  static fetch(source) {
    return AXIOS.get(`admin/${source}/appointments`);
  }

  // Com `page`, o back devolve só a página e o total no header Total-Count.
  static fetchFiltered(source, date, page) {
    return AXIOS.get(`admin/${source}/appointments`, {
      params: { filter: date, page }
    });
  }

  static cancelation(appointment) {
    return AXIOS.post("appointments/cancel", appointment);
  }

  static reschedule(appointmentId, payload) {
    return AXIOS.post(`appointments/${appointmentId}/reschedule`, {
      appointment_reschedule: payload
    });
  }

  static adminCancelation(appointmentId, note) {
    return AXIOS.post(`admin/appointments/${appointmentId}/cancel`, { note });
  }

  static finish(appointmentId) {
    return AXIOS.post(`admin/appointments/${appointmentId}/finish`);
  }

  // Consulta do próprio beneficiário. Diferente de `showAppointment`, que
  // aponta para o namespace admin e só o profissional/secretária acessa.
  static showPatientAppointment(appointmentId) {
    return AXIOS.get(`appointments/${appointmentId}`);
  }

  // Avaliação da consulta — Edital INAS, Anexo V, item 3.8.
  // Contrato único para webapp, Android e iOS.
  static fetchTestimonial(appointmentId) {
    return AXIOS.get(`appointments/${appointmentId}/testimonial`);
  }

  static createTestimonial(appointmentId, payload) {
    return AXIOS.post(`appointments/${appointmentId}/testimonial`, {
      testimonial: payload
    });
  }

  static earnings(appointmentId) {
    return AXIOS.get(`admin/appointments/${appointmentId}/earnings`);
  }

  static notes(description, appointmentId) {
    return AXIOS.post("admin/appointment_notes", {
      appointment_note: {
        description: description,
        appointment_id: appointmentId
      }
    });
  }

  static fetchNotes(appointmentId) {
    return AXIOS.get(`admin/appointment_notes?appointment_id=${appointmentId}`);
  }

  static fetchNotesByPatient(patientId) {
    return AXIOS.get(`admin/appointment_notes?patient_id=${patientId}`);
  }

  static createAppointmentByNurse(payload) {
    return AXIOS.post("admin/appointments", { appointment: payload });
  }

  static showAppointment(payload) {
    return AXIOS.get(`admin/appointments/${payload.id}`);
  }

  static pendingPayment(appointmentId) {
    return AXIOS.get(`appointments/${appointmentId}/pending_payment`);
  }

  static payWithCreditCard(appointmentId, creditCardId) {
    return AXIOS.post(`appointments/${appointmentId}/pay`, {
      credit_card_id: creditCardId
    });
  }

  static fetchPatientExamAttachments() {
    return AXIOS.get("/exam_attachments");
  }

  static listExamAttachments(appointmentId) {
    return AXIOS.get(`appointments/${appointmentId}/exam_attachments`);
  }

  static listAdminExamAttachments(appointmentId) {
    return AXIOS.get(`admin/appointments/${appointmentId}/exam_attachments`);
  }

  static uploadExamAttachment(appointmentId, payload) {
    return AXIOS.post(`appointments/${appointmentId}/exam_attachments`, {
      exam_attachment: payload
    });
  }

  static deleteExamAttachment(appointmentId, examId) {
    return AXIOS.delete(
      `appointments/${appointmentId}/exam_attachments/${examId}`
    );
  }
}
